// Estilos compartidos de los informes por puesto, procedimientos y atención prioritaria (mismo aspecto que los
// registros firmados). Todo en columnas que se apilan: usable a 360 px.
import type React from 'react';

export const S = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '12px 8px', overflowY: 'auto' } as React.CSSProperties,
  caja: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, width: '100%', maxWidth: 820, boxSizing: 'border-box', margin: 'auto 0' } as React.CSSProperties,
  cabecera: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10, padding: '16px 16px 10px', borderBottom: '1px solid #334155' } as React.CSSProperties,
  cuerpo: { padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 14 } as React.CSSProperties,
  bloque: { background: '#0f172a', border: '1px solid #334155', borderRadius: 10, padding: 12, display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0 } as React.CSSProperties,
  h2: { color: '#e2e8f0', fontSize: '1.05rem', fontWeight: 700, margin: 0 } as React.CSSProperties,
  h3: { color: '#e2e8f0', fontSize: '0.92rem', fontWeight: 700, margin: 0 } as React.CSSProperties,
  nota: { color: '#94a3b8', fontSize: '0.78rem', margin: 0, lineHeight: 1.45 } as React.CSSProperties,
  texto: { color: '#cbd5e1', fontSize: '0.84rem', margin: 0, lineHeight: 1.45, overflowWrap: 'anywhere' } as React.CSSProperties,
  fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', padding: '8px 0', borderTop: '1px solid rgba(51,65,85,0.6)' } as React.CSSProperties,
  botones: { display: 'flex', gap: 8, flexWrap: 'wrap' } as React.CSSProperties,
  input: { width: '100%', boxSizing: 'border-box', background: '#0f172a', border: '1px solid #334155', borderRadius: 8, color: '#e2e8f0', padding: '9px 10px', fontSize: '0.88rem' } as React.CSSProperties,
  etiqueta: { color: '#94a3b8', fontSize: '0.76rem', display: 'flex', flexDirection: 'column', gap: 4, flex: '1 1 160px', minWidth: 0 } as React.CSSProperties,
  rejilla: { display: 'flex', flexWrap: 'wrap', gap: 8 } as React.CSSProperties,
  error: { color: '#f87171', fontSize: '0.82rem', margin: 0 } as React.CSSProperties,
  ok: { color: '#2FBF71', fontSize: '0.82rem', margin: 0 } as React.CSSProperties,
  pestanas: { display: 'flex', gap: 6, flexWrap: 'wrap' } as React.CSSProperties,
};

export const boton = (tipo: 'primario' | 'secundario' | 'peligro' = 'secundario', deshabilitado = false): React.CSSProperties => ({
  padding: '9px 14px', borderRadius: 8, fontWeight: 600, fontSize: '0.84rem', cursor: deshabilitado ? 'not-allowed' : 'pointer', opacity: deshabilitado ? 0.55 : 1,
  minHeight: 40,
  ...(tipo === 'primario' ? { background: '#2FBF71', border: '1px solid #2FBF71', color: '#0f172a' }
    : tipo === 'peligro' ? { background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.4)', color: '#f87171' }
      : { background: 'transparent', border: '1px solid #475569', color: '#cbd5e1' }),
});

export const COLOR_ESTADO: Record<string, string> = {
  vigente: '#2FBF71', borrador: '#f59e0b', sin_informe: '#94a3b8', vencido_reciente: '#f59e0b', vencido: '#f87171',
  pendiente: '#94a3b8', en_curso: '#f59e0b', cerrada: '#2FBF71',
};
export const chip = (color: string): React.CSSProperties => ({
  display: 'inline-block', padding: '2px 8px', borderRadius: 999, fontSize: '0.72rem', fontWeight: 600, color, border: `1px solid ${color}`, whiteSpace: 'nowrap',
});

export const msg = (e: unknown) => (e instanceof Error ? e.message : String(e));

/** Abre una URL firmada en la misma acción del clic (Safari bloquea window.open después de una espera). */
export function abrirConUrl(promesa: Promise<string>) {
  const v = window.open('', '_blank');
  if (v) v.opener = null;
  promesa.then(url => { if (v) v.location.href = url; else window.open(url, '_blank', 'noopener,noreferrer'); })
    .catch(e => { v?.close(); alert(msg(e)); });
}

// dd/mm/aaaa: una fecha sin hora, tal cual; un instante (approved_at), en el día de Ecuador (lib/fechas).
export { fechaEc } from '../../lib/fechas';
